export function useSortTable(rows, sort) {
    const sortTable = (column) => {
        // Invert the direction if we've already sorted on this field
        if (sort.value.field === column.field) {
            sort.value.direction = sort.value.direction === 'asc' ? 'desc' : 'asc';
        }

        sort.value.field = column.field;
        rows.value = rows.value.filter(r => r.level === undefined);

        rows.value.sort((a, b) => {
            const aField = a.raw ? a.raw[column.field] : a[column.field];
            const bField = b.raw ? b.raw[column.field] : b[column.field];

            if (aField < bField) {
                return sort.value.direction === 'asc' ? -1 : 1;
            }

            if (aField > bField) {
                return sort.value.direction === 'asc' ? 1 : -1;
            }

            return 0;
        });
    };

    return {
        sortTable,
    };
}
